var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.646 2.646a.5.5 0 0 1 .708 0l1.666 1.667a.5.5 0 1 1-.707.707L8.5 4.207V7.5h3.293l-.813-.813a.5.5 0 1 1 .707-.707l1.667 1.666a.5.5 0 0 1 0 .708l-1.667 1.666a.5.5 0 1 1-.707-.707l.813-.813H8.5v3.293l.813-.813a.5.5 0 1 1 .707.707l-1.666 1.667a.5.5 0 0 1-.708 0L5.98 11.687a.5.5 0 1 1 .707-.707l.813.813V8.5H4.207l.813.813a.5.5 0 1 1-.707.707L2.646 8.354a.5.5 0 0 1 0-.708L4.313 5.98a.5.5 0 0 1 .707.707l-.813.813H7.5V4.207l-.813.813a.5.5 0 0 1-.707-.707z",
    clipRule: "evenodd"
  })));
};
export { SvgMove as ReactComponent };
export default __webpack_public_path__ + "194ec36809e11f689a153beb4969daaa.svg";